'use client';

// ОДИН запрос /api/version на всех слушателей (ТЗ релиза П2): сверку сборки ведёт
// PwaUpdater, гейт «Обновите приложение» подписан на те же ответы — второго опроса
// сервера нет. Одновременные вызовы делят один запрос в полёте.

export interface VersionInfo {
  /** Идентификатор сборки сайта на сервере (null — ответ без поля). */
  version: string | null;
  /** Минимальная сборка iOS (0 — выключено). */
  iosMinBuild: number;
  /** Ссылка на App Store ('' — нет). */
  iosStoreUrl: string;
}

/** Разбор ответа ручки: мусор и старый сервер без новых полей → безопасные значения. */
export function parseVersionPayload(j: unknown): VersionInfo {
  const o = (j && typeof j === 'object' ? j : {}) as Record<string, unknown>;
  const min = Number(o.iosMinBuild);
  return {
    version: typeof o.version === 'string' && o.version ? o.version : null,
    iosMinBuild: Number.isFinite(min) && min > 0 ? Math.floor(min) : 0,
    iosStoreUrl: typeof o.iosStoreUrl === 'string' ? o.iosStoreUrl : '',
  };
}

type Listener = (v: VersionInfo) => void;
const listeners = new Set<Listener>();
let inflight: Promise<VersionInfo> | null = null;
let last: VersionInfo | null = null;

/** Запросить версию. Бросает при сетевой ошибке (звонящий решает, что делать). */
export function fetchVersion(): Promise<VersionInfo> {
  if (inflight) return inflight;
  const p = fetch('/api/version', { cache: 'no-store' })
    .then((r) => r.json() as Promise<unknown>)
    .then((j) => {
      const v = parseVersionPayload(j);
      last = v;
      for (const l of listeners) {
        try {
          l(v);
        } catch {
          /* слушатель не роняет опрос */
        }
      }
      return v;
    })
    .finally(() => {
      inflight = null;
    });
  inflight = p;
  return p;
}

/** Подписка на каждый удачный ответ /api/version. Возвращает отписку. */
export function onVersion(cb: Listener): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

/** Последний полученный ответ (null — ещё не было). */
export function lastVersion(): VersionInfo | null {
  return last;
}
